export const getVacationStatusById = (id,vacationStatuses) =>{
    for (const status of vacationStatuses) {
        if(status["@id"]===id)return status
    }
}

